class BasicSystemForm {
    constructor(formID, availableSystemGroups, systemID = null) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.formID = formID;
        this.systemID = systemID;

        this.initSystemGroupsTagify(availableSystemGroups);
        this.changeSystemType();
        this.changeShortcutInApp();
        this.systemFormValidation();

        if(window.location.href.indexOf('#add_system') !== -1) {
            new bootstrap.Modal(document.getElementById('create_system_modal'), {}).show();
        }
    }
    fillFormWithSystemInfo(systemInfo, isDuplicate = true){
        let form = document.getElementById(this.formID);
        let jQueryForm = $(form);

        if(form) {
            // Icon + name
            if(systemInfo.iconID){
                form.querySelector('#add-system-icon').src = '/media/goodaccess/icons/system/' + systemInfo.iconID + '.svg';
                form.querySelector('input[name="iconID"]').value = systemInfo.iconID;
            }
            form.querySelector('input[name="name"]').value = (systemInfo.name ? (systemInfo.name + (isDuplicate ? ' - duplicate' : '')) : '');
            form.querySelector('textarea[name="description"]').value = (systemInfo.description ? systemInfo.description : '');
            // Shortcut in app
            if (systemInfo.customUri) {
                form.querySelector('input[name="showSystemInApp"]').checked = true;
                form.querySelector('input[name="customUri"]').value = systemInfo.customUri;
            } else {
                form.querySelector('input[name="showSystemInApp"]').checked = (systemInfo.length === 0); // If the systemInfo is empty -> this is a new system creation and the checkbox must be checked
                form.querySelector('input[name="customUri"]').value = '';
            }
            // Groups
            console.log(systemInfo);
            const inputElm = form.querySelector('input[name=groups]');
            if (inputElm.__tagify) {
                inputElm.__tagify.removeAllTags();
                if (systemInfo.groupsArr && systemInfo.groupsArr.length > 0) {
                    inputElm.__tagify.addTags(systemInfo.groupsArr);
                }
            }
            // Access Cards
            let accessCards = [];
            if(systemInfo.accessCards){
                for (let accessCard of systemInfo.accessCards) {
                    accessCards.push(accessCard.uuid);
                }
            }
            jQueryForm.find('select[name="accessCard\[\]"]').val(accessCards).trigger('change');
            // Type + host/url
            if (systemInfo.services && systemInfo.services.length === 1) {
                form.querySelector('input[name="url"]').value = systemInfo.host;
                form.querySelector('input[name="host"]').value = systemInfo.host;
                jQueryForm.find('select[name="type"]').val(systemInfo.services[0].type).trigger('change');
                jQueryForm.find('select[name="protocol"]').val(systemInfo.services[0].protocolTypeID).trigger('change');
                form.querySelector('input[name="port"]').value = systemInfo.services[0].port;
            } else {
                jQueryForm.find('select[name="type"]').val('HTTPS').trigger('change');
                jQueryForm.find('select[name="protocol"]').val(1).trigger('change');
                form.querySelector('input[name="port"]').value = '';
                form.querySelector('input[name="url"]').value = '';
                form.querySelector('input[name="host"]').value = '';
            }
        }
    }
    /** Init tagify inputs for groups in system form */
    initSystemGroupsTagify(availableSystemGroups){
        let notice = $('#systemFormGroupNotice');
        /** In create system form  */
        const groupsInput = document.querySelector('#'+this.formID+' input[name=groups]');
        if(groupsInput){
            let tagify = new SystemGroupsTagify(groupsInput, availableSystemGroups);
            tagify.on('add', function(e){
                if(e.detail.data.accessCards && notice){
                    notice.removeClass('d-none');
                }
            }).on('remove', function(e){
                let values = e.detail.tagify.value;
                for(let i in values){
                    if(values[i].accessCards === true){
                        break;
                    }
                }
                notice.addClass('d-none');
            });
        }
    }
    /** Show different inputs based on system type */
    changeSystemType(){
        const thisClass = this;
        let form = $('#'+this.formID);
        form.find('select[name=type]').on('change', function(e) {
            const type = $(this).val();
            const protocol = $(this).find(":selected")[0].attributes.protocol.value;
            let port = $(this).find(":selected")[0].attributes.port.value;

            let url = form.find('input[name="url"]');
            if(url.val().includes('://')) {
                url.val(url.val().split('://')[1].replace(/\/$/, '').replace(/^www./, '').split(':')[0]);
            }

            if(!port){
                port = form.find('input[name=port]').val()
            }
            thisClass.addProtocolHostPort(form, type, protocol, port);
            thisClass.showOrHideCustomUri(type, form.find('input[name=showSystemInApp]').is(':checked'));
        });
    }
    changeShortcutInApp(){
        let thisClass = this;
        let form = $('#'+this.formID);
        let showShortcutInApp = form.find('input[name=showSystemInApp]');

        showShortcutInApp.on('change', function () {
            thisClass.showOrHideCustomUri(form.find('select[name=type]').val(), this.checked);
        });
    }
    showOrHideCustomUri(type, showShortcutInApp){
        let form = $('#'+this.formID);
        let customUriContainer = form.find('.custom-uri-container');
        let showSystemInAppPopover = form.find('.show-system-in-app-popover');

        if(type === 'HTTP' || type === 'HTTPS'){
            showSystemInAppPopover.attr('data-bs-content', 'System Shortcuts help users access your defined systems directly from the GoodAccess Client Application with a single click.');
            customUriContainer.slideUp(200, 'linear');
        } else {
            if(showShortcutInApp){
                showSystemInAppPopover.attr('data-bs-content', 'A System shortcut is a small icon in the GoodAccess application for quick access to a given system. When you click on it, the Shortcut link/URI opens.');
                customUriContainer.slideDown(200, 'linear');
            } else {
                showSystemInAppPopover.attr('data-bs-content', 'System Shortcuts help users access your defined systems directly from the GoodAccess Client Application with a single click.');
                customUriContainer.slideUp(200, 'linear');
            }
        }

        new bootstrap.Popover(showSystemInAppPopover);
    }
    /** Show different inputs based on type in both forms - create and edit */
    addProtocolHostPort(form, type, protocol, port){
        let protocolContainer = form.find('.protocol-container');
        let urlContainer = form.find('.url-container');
        /** If type is http or https show only url input */
        if(type === "HTTP" || type === "HTTPS"){
            protocolContainer.slideUp(200, 'linear');
            urlContainer.show();
        } else {
            let hostInput = form.find('input[name="host"]');
            /** Show protocol, host, port and Shortcut link/URI */
            if(type !== 'Custom'){
                form.find('input[name="port"]').val(port).prop('disabled', true);
                form.find('select[name="protocol"]').val((protocol !== 'UDP' ? 1 : 2)).prop('disabled', true).change();
                form.find('input[name="customUri"]').val(type.toLowerCase()+'://'+hostInput.val()+':'+port);
            } else {
                form.find('select[name="protocol"]').prop('disabled', false);
                form.find('input[name="port"]').prop('disabled', false);
            }
            this.autocompleteCustomUri(form, hostInput, type, port);
            urlContainer.hide();
            protocolContainer.slideDown(200, 'linear');
        }
    }
    /** Automatic fill Shortcut link/URI from type host and port */
    autocompleteCustomUri(form, hostInput, type, port){
        hostInput.keyup(function() {
            if(type !== 'Custom'){
                form.find('input[name="customUri"]').val(type.toLowerCase()+'://'+hostInput.val()+':'+port);
            }
        });
    }
    systemFormValidation(){
        const thisClass = this;
        let form = document.getElementById(this.formID);

        if(form){
            let formContainer = $(form);

            let submitButton = form.querySelector('button[type=submit]');
            let deleteButton = form.querySelector('#edit_system_form_delete');
            let icmpProtocolEl = form.querySelector('input[name="icmpProtocol"]');

            const selectType = formContainer.find('select[name="type"]');
            const inputPort = formContainer.find('input[name="port"]');
            const inputHost = formContainer.find('input[name="host"]');

            formContainer.find('input[name="url"]').on('change', function (e) {
                if($(this).val().includes('://')){
                    let type = $(this).val().split('://')[0].toUpperCase();
                    let host = $(this).val().split('://')[1].replace(/^www./, ''); // Remove :// and / from the end and www. from the beginning
                    let port = host.split('/')[0].split(':')[1];
                    host = host.split(':')[0];

                    $(this).val(host);

                    if(type && type !== selectType.val()){
                        const selectedTypeEl = $(selectType).find('[value="'+type+'"]')[0];
                        const typePort = selectedTypeEl.attributes.port.value;
                        if(type !== 'HTTPS' && type !== 'HTTP'){
                            inputHost.val(host.replace(/\/$/, '').split('/')[0].split(':')[0]);
                            if(!port || typePort !== port){
                                type = 'Custom';
                                inputPort.val(port);
                            }
                        }

                        selectType.val(type).trigger('change');
                    }
                }
            });

            let excludeUrl = function (){
                let type = formContainer.find('select[name=type]').val();
                return !(type === "HTTP" || type === "HTTPS");
            }
            let excludeNotUrl = function (){
                let type = formContainer.find('select[name=type]').val();
                return (type === "HTTP" || type === "HTTPS");
            }

            let fv = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required',
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Name cannot be over 45 characters',
                                },
                                regexp: {
                                    regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                    message: 'Only these special characters are allowed. (_.-)',
                                },
                            }
                        },
                        'description': {
                            validators: {
                                stringLength: {
                                    max: 256,
                                    message: 'Description cannot be over 45 characters',
                                },
                            }
                        },
                        'type': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            }
                        },
                        'url': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 4,
                                    max: 110,
                                    message: 'URL has to be between 4 and 110 characters long',
                                },
                                regexp: {
                                    regexp: /^(http(s?):\/\/)?(((www\.)?[a-zA-Z0-9\.\-\_\@]+(\.[a-zA-Z]{1,})+)(:[0-9]{1,5})?|(\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b))(:[0-9]{1,5})?(\/[a-zA-Z0-9\_\-\s\.\/\?\%\#\&\=]*)?$/,
                                    message: 'Invalid format',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '/systems/?do=checkSystemValidation',
                                    data: function () {
                                        let dataJson = {
                                            organizationID: thisClass.organizationID,
                                            type: formContainer.find('select[name="type"]').val()
                                        }
                                        if(thisClass.systemID){
                                            dataJson.systemID = thisClass.systemID;
                                        }
                                        return dataJson;
                                    },
                                }
                            }
                        },
                        'protocol': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'host': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 3,
                                    max: 100,
                                    message: 'URL has to be between 3 and 110 characters long',
                                },
                                regexp: {
                                    regexp: /^([a-z.\-\d])+$|^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))$/,
                                    message: 'Colon and slash are not allowed characters',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '/systems/?do=checkSystemValidation',
                                    data: function () {
                                        let dataJson = {
                                            organizationID: thisClass.organizationID,
                                            protocol: formContainer.find('select[name="protocol"]').val(),
                                            port: formContainer.find('input[name="port"]').val(),
                                            type: formContainer.find('select[name="type"]').val(),
                                            isAdvanced: false
                                        }
                                        if(thisClass.systemID){
                                            dataJson.systemID = thisClass.systemID;
                                        }
                                       return dataJson;
                                    },
                                }
                            }
                        },
                        'port': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 11,
                                    message: 'Port cannot be over 11 characters',
                                },
                                callback: {
                                    message: 'You have to type in valid port/range',
                                    callback: function (input) {
                                        /** Public ports cant contain udp ports (500,4500,1194)(0-65535) and private (0-65535) */
                                        if(input.value.includes('-')){
                                            const splittedArr = input.value.split('-');
                                            if(splittedArr.length <= 2){
                                                if(!isNaN(splittedArr[0]) && !isNaN(splittedArr[1])){
                                                    if(+splittedArr[0] < +splittedArr[1]){
                                                        if(splittedArr[1] <= 65535 && splittedArr[1] > 0 && splittedArr[0] > 0 && splittedArr[0] <= 65535){
                                                            return true;
                                                        }
                                                    }
                                                }
                                            }
                                        } else {
                                            if(!isNaN(+input.value)){
                                                if(+input.value > 0 && +input.value <= 65535){
                                                    return true;
                                                }
                                            }
                                        }
                                        return false;
                                    }
                                }
                            }
                        },
                        'customUri': {
                            validators: {
                                regexp: {
                                    regexp: /^((.)*:\/\/)?((www\.)?([a-zA-Z0-9\-_]+@)?((([a-zA-Z0-9\-_]+\.)+[a-zA-Z]{2,})|(\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b))(:[0-9]{1,5})?(\/[a-zA-Z0-9\-_\/\.\?\%\#\&\=]*)?)$/,
                                    message: 'Invalid format',
                                },
                                stringLength: {
                                    max: 110,
                                    message: 'Shortcut link/URI cannot be over 110 characters',
                                },
                                callback: {
                                    message: 'This field is required',
                                    callback: function(input) {
                                        const showSystemInApp = form.querySelector('[name="showSystemInApp"]');
                                        if(showSystemInApp.checked){
                                            return input.value.length !== 0;
                                        }
                                        return true;
                                    }
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                host: 0.5,
                                url: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                            onPlaced: function (e) {
                                if (e.field === 'type') {
                                    e.iconElement.classList.add('d-none');
                                }
                            },
                        }),
                        excluded: new FormValidation.plugins.Excluded({
                            excluded: function(field, element, elements) {
                                if(field === 'url'){
                                    return excludeUrl();
                                } else if(field === 'protocol' || field === 'host' || field === 'port' || field === 'customUri') {
                                    return excludeNotUrl();
                                }
                                return false;
                            }
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.classList.contains('d-none') || e.element.classList.contains('form-select')){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                new DismissModal(thisClass.systemID ? 'edit_system_modal' : 'create_system_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
                if(deleteButton){
                    deleteButton.disabled = true;
                }
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal(thisClass.systemID ? 'edit_system_modal' : 'create_system_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
                if(deleteButton){
                    deleteButton.disabled = false;
                }
            }).on('core.validator.validated', function (e) {
                if(icmpProtocolEl && e.validator === 'remote' && (e.field === 'url' || e.field === 'host')){
                    let icmpContainer = icmpProtocolEl.closest('#icmp-protocol-container');
                    if(icmpContainer){
                        if(e.result.meta.branchRange){
                            icmpContainer.classList.remove('d-none');
                        } else {
                            icmpContainer.classList.add('d-none');
                            icmpProtocolEl.checked = false;
                        }
                    }
                }
            });

            const protocolSelect = formContainer.find('select[name="protocol"]');
            const portInput = formContainer.find('input[name="port"]');
            protocolSelect.on('change', function (e) {
                fv.validateField('host');
            });

            let typingTimer;
            portInput.bind("change",function(){
                fv.validateField('host');
            });
            portInput.on('keyup', function () {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(() => {
                    fv.validateField('host');
                }, 1000);
            });
        }
    }
}
window.BasicSystemForm = BasicSystemForm;